module.exports = __webpack_public_path__ + "img/img1.6dc59d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/04/img1.png
// module id = 53
// module chunks = 0